import BaseError from './BaseError'
import MissingArgumentsError from './MissingArgumentsError'

export default {
  BaseError,
  MissingArgumentsError
}
